import { Attributes, List, Misc, ModelBase, Rules, Validation } from '@singularsystems/neo-core';
import InterestRate from './InterestRate';
import { InterestRateModifier } from './InterestRateModifier.enum';
import { InterestCalculationType } from './InterestCalculationType.enum';
import DateCycle from '../Dividends/DateCycle';

export default class InterestRateType extends ModelBase {
    static typeName = "InterestRateType";

    constructor() {
        super();
        this.makeObservable();
    }

    public interestRateTypeId: number = 0;

    @Rules.Required()
    @Rules.StringLength(50)
    public rateTypeName: string = "";

    @Rules.Required()
    @Rules.StringLength(10)
    public shortName: string = "";

    @Rules.StringLength(200)
    public description: string = "";

    public modifierType: InterestRateModifier | null = null;

    public interestCalculationType: InterestCalculationType = InterestCalculationType.Linear;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public rateFrequencyName: string = "";

    @Attributes.Nullable()
    public rateFrequencyId: number | null = null;

    @Attributes.ChildObject(DateCycle)
    public rateFrequency: DateCycle | null = null;

    @Attributes.NullableBoolean()
    public exemptOnly: boolean | null = null;

    public issuerOnly: boolean = false;

    public isPrime: boolean = false;

    public isActive: boolean = true;

    @Attributes.Integer()
    public ordinal: number = 99;

    public interestRates = new List(InterestRate);

    @Attributes.Nullable()
    public productTypeId: number | null = null;

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public isLinkedToInvestments: boolean = false;

    @Attributes.Nullable()
    @Attributes.Integer()
    public dayOffset: number | null = null;

    @Attributes.Nullable()
    public parentInterestRateTypeId: number | null = null;

    public childInterestRateTypes = new List(InterestRateType);

    @Attributes.Nullable()
    public importConfigId: number | null = null;

    @Rules.StringLength(50)
    public importRowIdentifier: string | null = null;

    // Client only properties / methods

    public get isZaronia(): boolean {
        return this.interestCalculationType === InterestCalculationType.Zaronia;
    }

    public get isChild(): boolean {
        return this.parentInterestRateTypeId != null;
    }

    public get isParent(): boolean {
        return this.childInterestRateTypes.length > 0;
    }

    @Attributes.NoTracking()
    public showChildRates = false;

    public get isExpanded(): boolean | null {
        if (this.isNew || !this.isParent) {
            return null;
        }
        else return this.showChildRates;
    }

    public set isExpanded(value: boolean) {
        this.showChildRates = value;
    }

    public appliesToCounterparty(isInvestor: boolean) {
        return !this.issuerOnly || !isInvestor;
    }

    public appliesToExemptType(isExempt: boolean) {
        return this.exemptOnly === null || this.exemptOnly === isExempt;
    }

    protected static addBusinessRules(rules: Validation.Rules<InterestRateType>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.rateTypeName) {
            return "New interest rate type";
        } else {
            return this.rateTypeName;
        }
    }
}